/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-08-28 13:55:15
 */
import LayoutEX from "@/views/layout/LayoutEx";
import config from "@/configs/pathConfigures";
import TenantLayout from "../../views/schoolManager/container.vue";
export default {
    name: "tenant",
    path: config.prefixUrl,
    component: LayoutEX,
    redirect: { name: "homeIndex" },
    props: {
        routeMapClass: "route-map__float",
    },
    meta: { title: "用户及权限" },
    children: [
        {
            name: "userManager",
            path: "/user",
            component: () => import("../../views/schoolManager/userManager.vue"),
            meta: {title: "用户管理"}
        },
        {
            name: "frozenUserManager",
            path: "/user/frozen",
            component: () => import("../../views/schoolManager/freezeUserManager.vue"),
            meta: {title: "已冻结用户"}
        },
    ],
};
